module.exports = __webpack_public_path__ + "static/img/app-sub-img04@w.6b3fa67.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/app-sub-img04@w.png
// module id = 8hu5
// module chunks = 0